import { InjectionToken } from '@angular/core';

import { DoodReconstructedCart } from '@core/models/cart.model';

/** Runtime VM emitted by `CartItemListBlock` data sources. */
export type CartItemListBlockViewModel = {
  /** `undefined` while loading; an array (possibly empty) once loaded. */
  reconstructedCart: DoodReconstructedCart[] | undefined;
  isOrderValidationInProgress: boolean;
};

export const CART_ITEM_LIST_BLOCK_LOADING_VM: CartItemListBlockViewModel = {
  reconstructedCart: undefined,
  isOrderValidationInProgress: false,
};

export interface CartItemListBlockDataSource {
  readonly vm$: import('rxjs').Observable<CartItemListBlockViewModel>;
}

export const CART_ITEM_LIST_BLOCK_DATA_SOURCE = new InjectionToken<CartItemListBlockDataSource>(
  'CART_ITEM_LIST_BLOCK_DATA_SOURCE',
);
